import CustomQuoteIcon from "@/assets/iconComponents/CustomQuoteIcon";

function ProfessionalCard({ title, description, position, image, className }) {
  return (
    <div
      className={`bg-[#95C3A8] rounded-[20px] relative shadow-md w-full h-full overflow-hidden ${className}`}
    >
      {/* Image section - clean, centered, true aspect ratio */}
      <div
        className="w-full aspect-[4/3] rounded-t-[20px] rounded-br-[50px] sm:rounded-br-[70px] md:rounded-br-[80px] lg:rounded-br-[90px] xl:rounded-br-[100px]"
        style={{
          backgroundImage: `url(${image?.src || image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        }}
      />

      {/* Content section */}
      <div className="p-4 sm:p-5 md:p-6 lg:p-6 xl:pt-2 xl:pb-5 w-[95%] flex flex-col justify-between items-stretch flex-1">
        <div className="mb-19 md:mb-22">
          <h2 className="text-20px-semibold text-[#5C2483] font-medium">{position}</h2>

          <div className="mt-10 sm:mt-2 md:mt-3 lg:mt-3 body-copy-small-text min-h-[160px] lg:min-h-auto text-[#5C2483]">
            <CustomQuoteIcon
              size={18}
              color="#5C2483"
              className="inline-block align-text-top mr-1"
            />
            <span className="align-middle flex-grow">{title}</span>
            <CustomQuoteIcon
              size={18}
              color="#5C2483"
              rotate={180}
              className="inline-block align-text-top ml-1"
            />
          </div>
        </div>

        <div className="absolute bottom-0 left-0 p-4 sm:p-5 md:p-6 lg:p-6 xl:pt-2 xl:pb-5 mt-auto">
          <span className="text-[#5C2483] text-20px-normal flex flex-col gap-1">
            {description?.split("\n").map((text, idx) => (
              <div key={idx}>{text}</div>
            ))}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ProfessionalCard;
